// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__229H2","col":"styles_col__3wJcf","actions":"styles_actions__3Q5aB","conflict":"styles_conflict__1dmP9"};